import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ontruck/orc';
import ContactsList from 'components/ContactsList';
import { AddressModal } from 'components/AddressModal';
import AddressDeleteModal from 'components/AddressDeleteModal';
import { useTranslation } from 'react-i18next';
// container
import { actions as addressesActions } from 'state/addresses';
import { actions as orderActions } from 'state/order';
import { useDispatch } from 'react-redux';
import useNavigateToMainPage from 'utils/hooks/useNavigateToMainPage';
import { Main, GridRow } from 'refactored/ui/layout';
import { Title } from 'refactored/ui/typography';
import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';
// styles
import styled, { css } from 'styled-components';
import { gridSizes, media } from 'utils/style';
import { userIsAuthenticatedRedir } from 'components/auth/hoc';

const headerContainerRegularCSS = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
`;
const headerContainerMobileCSS = css`
  padding: ${gridSizes('M')};
`;

const HeaderContainer = styled.div`
  ${headerContainerRegularCSS}
  ${media.lessThan('extraSmall')`${headerContainerMobileCSS}`}
`;

const AddressesPage = ({ className }) => {
  const { t } = useTranslation('AddressesPage');
  const [listVersion, setListVersion] = useState(0);
  const [addressModalIsOpened, setAddressModalIsOpened] = useState(false);
  const [deleteAddressModalIsOpen, setDeleteAddressModalIsOpen] =
    useState(false);
  const [address, setAddress] = useState({});
  const dispatch = useDispatch();

  const handleBack = useNavigateToMainPage();

  const openAddressModal = (address) => {
    setAddressModalIsOpened(true);
    if (address) {
      dispatch(addressesActions.zipcodeTyped(address));
      setAddress(address);
    }
  };

  const closeAddressModal = (payload) => {
    const hasToUpdate = (payload && payload.hasToUpdate) || false;
    setListVersion(hasToUpdate ? listVersion + 1 : listVersion);
    setAddressModalIsOpened(false);
    setAddress({});
    dispatch(addressesActions.setCityData({ cityData: {} }));
  };

  const openDeleteAddressModal = () => {
    setDeleteAddressModalIsOpen(true);
  };
  const closeDeleteAddressModal = (payload) => {
    const deletedId = (payload && payload.deletedId) || false;
    setDeleteAddressModalIsOpen(false);
    if (deletedId) {
      setListVersion(listVersion + 1);
      setAddressModalIsOpened(false);
    }
    dispatch(addressesActions.setCityData({ cityData: {} }));
  };

  const handleStartOrderWithAddress = (address) => {
    dispatch(orderActions.startOrderWithAddress({ address }));
  };
  return (
    <AuthenticatedUserView className={className} handleBack={handleBack}>
      <Main>
        <GridRow>
          <HeaderContainer>
            <Title>{t('title')}</Title>
            <Button
              text={t('new_contact')}
              type="button"
              size="L"
              icon="plus"
              iconPosition="left"
              onClick={openAddressModal}
            />
          </HeaderContainer>
        </GridRow>

        <GridRow>
          <ContactsList
            key={listVersion}
            onClickEditAddress={openAddressModal}
            onClickStartWithAddress={handleStartOrderWithAddress}
            t={t}
          />
        </GridRow>

        {addressModalIsOpened && (
          <AddressModal
            onClose={closeAddressModal}
            address={address}
            canDelete
            handleDelete={openDeleteAddressModal}
          />
        )}
        {deleteAddressModalIsOpen && (
          <AddressDeleteModal
            onClose={closeDeleteAddressModal}
            address={address}
          />
        )}
      </Main>
    </AuthenticatedUserView>
  );
};

AddressesPage.propTypes = {
  className: PropTypes.string,
};

AddressesPage.defaultProps = {
  className: '',
};

export default userIsAuthenticatedRedir(AddressesPage);
